/**
 * @param {string} value
 */
function escapeCsvValue(value) {
  const text = String(value ?? '')
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`
  }
  return text
}

/**
 * @param {Array<{ key: string, label: string, getValue: (row: object) => string | number | boolean | null | undefined }>} columns
 * @param {object[]} rows
 * @returns {string}
 */
export function buildCsvContent(columns, rows) {
  const header = columns.map((column) => escapeCsvValue(column.label)).join(',')
  const body = rows.map((row) =>
    columns.map((column) => escapeCsvValue(column.getValue(row))).join(','),
  )
  return [header, ...body].join('\n')
}

/**
 * @param {string} filename
 * @param {string} content
 */
export function downloadCsvFile(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * @param {Array<{ key: string, label: string, getValue: (row: object) => string | number | boolean | null | undefined }>} columns
 * @param {object[]} rows
 * @param {string} filename
 */
export function exportRowsToCsv(columns, rows, filename) {
  downloadCsvFile(filename, buildCsvContent(columns, rows))
}
